import { useTranslation } from 'react-i18next';
import type { Project } from '@/mocks/projects';

export function useProjectI18n() {
  const { i18n } = useTranslation();
  const isEN = i18n.language === 'en';

  const t_title = (project: Project) => (isEN ? project.title_en : project.title);
  const t_tag = (project: Project) => (isEN ? project.tag_en : project.tag);
  const t_description = (project: Project) =>
    isEN ? project.description_en : project.description;
  const t_location = (project: Project) => (isEN ? project.location_en : project.location);
  const t_client = (project: Project) => (isEN ? project.client_en : project.client);

  return { t_title, t_tag, t_description, t_location, t_client };
}